window.variantId = null;

const updateCartCount = () => {
	fetch('/cart.js', {
		method: 'GET',
		headers: {
			'Content-Type': 'application/json'
		}
	})
	.then(result => result.json())
	.then(result => {
		const cartTotal = document.querySelectorAll('.totals__subtotal-value');
		document.querySelectorAll('[data-count]').forEach( count => {
			count.setAttribute('data-count', result.item_count);
			document.querySelectorAll('.c-cart-count').forEach( el => el.innerHTML = result.item_count);

			if (cartTotal) {
				// console.log(result.total_price, Number(result.total_price) === 0);
				cartTotal.forEach( count => {
					count.innerHTML = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(result.total_price / 100) + ' USD';
				})
			}
		});
	})
}

const rootForOpen = (forceOpen) => {
	const rootEl = document.querySelector("html");

	if (forceOpen) {
		rootEl.setAttribute('data-video-opened')
		return;
	}

	if (rootEl.hasAttribute('data-video-opened')) {
		rootEl.removeAttribute('data-video-opened')
	} else {
		rootEl.setAttribute('data-video-opened', true)
	}

}


const addItems = (items) => {
	return new Promise((resolve, reject) => {
		fetch(window.Shopify.routes.root + 'cart/add', {
			method: 'POST',
			headers: {
			'Content-Type': 'application/json'
			},
			body: JSON.stringify(items)
		})
		.then(response => {
			if (response.status === 200) {
				fetch('/cart.js', {
					method: 'GET',
					headers: {
						'Content-Type': 'application/json'
					}
				})
				.then(result => result.json())
				.then(result => {
					resolve(result);
				})
			} else {
				reject('failed');
			}
		})
		.catch((error) => {
			reject('failed');
			console.error('Error:', error);
		});
	})
}



const addToCartFnc = (e, itemsArray = null, addOnItem, quantity = null) => {
	if (e && e.target) {
		e.preventDefault();
	} else {
		console.log("missing event")
		return false;
	}

	const target = e.target;
	const productId = addOnItem ? Number(addOnItem) : target.getAttribute('data-id');
	let productQuanity = quantity || addOnItem ? 1 : itemsArray || document.querySelector(target.getAttribute('data-quantity-selector')).value || 1;

	target.classList.add("_adding");
	target.classList.remove("_added");

	let items = itemsArray || {
		'items': [{
			'id': Number(productId),
			'quantity': Number(productQuanity) || 1
		}]
	};

	return addItems(items).then((result) => {
		// window.location.href = "/cart";

		// console.log(result.item_count)

		// document.querySelectorAll(".header-cart__count").forEach(item => {
		// 	item.innerHTML = result.item_count;
		// 	item.setAttribute('data-count', result.item_count)

			target.classList.add("_added");
			target.classList.remove("_adding");

			document.querySelectorAll('[data-count]').forEach( count => {
				count.setAttribute('data-count', result.item_count);
				document.querySelectorAll('.c-cart-count').forEach( el => el.innerHTML = result.item_count);
			});

			setTimeout(() => {
				if (addOnItem) {
					target.classList.remove('tw-pointer-events-none');
					target.classList.remove('tw-cursor-pointer');
					target.classList.add('tw-cursor-pointer');
					target.removeAttribute('onclick');
					target.setAttribute('href', '/cart');
					target.setAttribute('title', 'Go to Cart');
				} else {
					target.classList.remove("_added");
				}
			}, 1000)
		// })

	}).catch((err) => {
		alert("Oops! Something went wrong. \nIf you continue to experience this issue, please contact Canvas support.")
		console.log(err);
	})
}

const handleAddToCart = () => {

	handlesAddToCart.forEach( cta => {

		cta.addEventListener("click", e => {
			addingToCart(e)
		})

	})
}

const addToCartFncWithPromo = (e, promo = null) => {
	if (promo) {
		const target = e.target;
		target.classList.add("_adding");
		target.classList.remove("_added");

		fetch(`/discount/${promo}`)
		.then(() => {
			return fetch("/cart/update.js", {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify({
				updates: {},
			})
			}).then(() => {
				addToCartFnc(e);
			});
		})
		.catch(function (error) {
			alert(`Promo Code "${ promo }" is not valid. \nPlease contact Canvas support.`)
			console.error("Error:", error);
		});
	} else {
		addToCartFnc(e);
	}
}


const _makeBuyObject = (listing, quantity = 1) => {
	if (!listing) return false;

	return new Promise((resolve, reject) => {
		const temp = [];
		listing.forEach( item => {
			temp.push({
				'id': item,
				'quantity': Number( quantity )
			})
		})

		if (temp.length) {
			resolve(temp);
		} else {
			reject('No items to add to cart');
		}

	})
}

const _individualItemsAddToCartFnc = (event, quanityAmount) => {
	const targetEvent = event || null;
	const listing = targetEvent.target.getAttribute('data-listing');
	const quantity = quanityAmount || targetEvent.target.parentNode.parentNode.querySelector(".js-quanity-selector input").value || 1;

	_makeBuyObject(JSON.parse(listing), quantity).then((items_to_add_to_cart) => {
		const items = { "items": items_to_add_to_cart };
		addToCartFnc(targetEvent, items)
	}).catch( error => {
		console.log(error)
	})

	if (event) event.preventDefault();
}


const _individualItemsAddToCartFncFeaturedSection = (event) => {
	_individualItemsAddToCartFnc(event, 1)
	if (event) event.preventDefault();
}

const fadeOut = async (el, delay = 150, duration = 500) => {
	const isCssTransition = el.classList.contains('tw-opacity-[var(--opacity)]') || false;

	return new Promise((resolve, reject) => {
		if (!isCssTransition) {
			el.style.opacity = 1;
		}

		(async function fade() {
			if (isCssTransition) {
				el.classList.add(`!tw-duration-${duration}`);
				el.addEventListener("transitionend", () => {
					resolve(el);
				});
				setTimeout(() => {
					el.style.setProperty('--opacity', '0');
				}, delay)
			} else {
				var val = parseFloat(el.style.opacity);

				if ((el.style.opacity -= .05) < 0) {
					el.style.display = "none";
					if(val === 1) {
						resolve(el);
					}
				} else {
					requestAnimationFrame(fade);
				}
			}
		})();
	});
}

const fadeIn = async (el, delay = 150, duration = 500) => {
	const isCssTransition = el.classList.contains('tw-opacity-[var(--opacity)]') || false;

	return new Promise((resolve, reject) => {
		if (!isCssTransition) {
			el.style.opacity = 0;
		}

		(async function fade() {
			if (isCssTransition) {
				el.classList.add(`!tw-duration-${duration}`);
				el.addEventListener("transitionend", () => {
					resolve(el);
				});
				setTimeout(() => {
					el.style.setProperty('--opacity', '100');
				}, delay)
			} else {
				var val = parseFloat(el.style.opacity);
				if (!((val += .05) > 1)) {
					el.style.opacity = val;
					requestAnimationFrame(fade);
					if(val === 1) resolve(el);
				}
			}
		})();
	})
}


const preload = src => new Promise(function (resolve, reject) {
	if (src) {
		const img = new Image();
		img.onload = () => {
			resolve({
				'img': img,
				'src': src
			});
		}
		img.onerror = reject;
		img.src = src;
	} else {
		reject('No image source provided')
	}
});

let count = 15;

const productImageSwap = (e, prevent = false, path = null, replacementImage = null, targetSelector = null, targetParentSelector = null) => {
	if (prevent === true) e.preventDefault();
	// let firstThumbnail = document.querySelector('c-product-thumnail > c-product-thumnails__thumbnail:first-child .c-product-thumnails__thumbnail-link[data-image]');
	// let newSrcPre = e.target.getAttribute('data-image');
	let newSrc = replacementImage || e.target.getAttribute('data-image');

	// if (newSrc.includes('no-image')) {
	// 	newSrc = firstThumbnail || newSrcPre;
	// }

	let target = targetSelector || document.querySelectorAll("._product-thumbnail-target")[0];
	let parentEl = targetParentSelector || target.parentNode;
	let isCssTransition = target.classList.contains('tw-opacity-[var(--opacity)]') || false;
	parentEl.classList.add('_loading');
	let temp = targetSelector ? targetSelector.cloneNode(true) : document.querySelectorAll("._product-thumbnail-target")[0].cloneNode(true);
	temp.style.setProperty('--zIndex', count++);
	temp.style.setProperty('--zindex', count++);

	if (isCssTransition) {
		temp.style.setProperty('--opacity', '0');
	} else {
		temp.style.opacity = 0;
	}

	preload(newSrc)
	.then(img => {
		return img?.src
	})
	.then(img => {
		parentEl.classList.add('_loaded');
		temp.setAttribute('src', img);
	})
	.then( () => {
		parentEl.classList.remove('loaded');
		parentEl.classList.remove('_loading');
		target.parentNode.prepend(temp);
	})
	.then(() => {
		fadeIn(temp)
		.then((el) => {
			el.parentNode.querySelectorAll(':not(:first-child)').forEach(siblings => {
				fadeOut(siblings, 1, 100).then( el => el.remove() );
			})
		})
	})
	.catch(err => console.error("Failed", err));
}


const variantSwap = (e, variantId, list, name = null, color = null, finish = null, lamp = null) => {
	window.variantId = variantId;
	productImageSwap(e, false);
	document.querySelector('._product-add-to-cart').setAttribute('data-id', variantId)

	if(variantId) {
		window.variantId = variantId;
	}
	if(color) {
		window.variantBaseType = color;
	}
	if(name) {
		window.variantName = name;
	}
	if(finish) {
		window.variantFinish = finish;
	}
	if(lamp) {
		window.variantColor = lamp;
	}
}



const addOnItem = (e, id, name, parent = null) => {
	const target = e.target;
	const targetOutput = parent ? document.querySelector(parent) : target;

	targetOutput.classList.add('!tw-border-secondary-accent');
	targetOutput.classList.add('tw-pointer-events-none');
	targetOutput.classList.add('_added');

	if (parent) {
		target.classList.add('!tw-border-secondary-accent');
		target.classList.add('tw-pointer-events-none');
	}

	if (addOnList && addOnList.length < 2) {
		addOnList.push(name);
		document.querySelector("._upgrades-output").innerHTML = addOnList.toString().replaceAll(',', ' + ');
		document.querySelector("._upgrades-output").parentNode.classList.add("_added")
		if (addOnList.length > 1) {
			document.querySelector("._upgrades-output").parentNode.classList.add("_multiples")
		}
	}
	addToCartFnc(e, null, id);
}



// const getPromoCodes = () => {
// 	return new Promise((resolve, reject) => {
// 		const queryString = window.location.search;
// 		const urlParams = new URLSearchParams(queryString);
// 		const promo1 = urlParams.get('promo1')
// 		const promo2 = urlParams.get('promo2')

// 		if (!promo1 && !promo2) resolve(null);

// 		resolve([promo1 || null, promo2 || null]);
// 	});
// }

// const setPromoCodes = async (code) => {
// 	return new Promise((resolve, reject) => {
// 		fetch(`/discount/${code}`)
// 		.then(() => {
// 			fetch('/cart/update.js', {
// 				method: 'POST',
// 				headers: {
// 					'Content-Type': 'application/json'
// 				},
// 				body: JSON.stringify({
// 					updates: {},
// 				}),
// 			}).then(() => {
// 				resolve(`"${code}" Promo Code Added YOUR Cart!`)
// 			})
// 		})
// 		.catch(function (error) {
// 			console.log(`Promo Code "${ code }" is not valid. \nPlease contact Canvas support.`)
// 			console.error("Error:", error);
// 		});
// 	});
// }

// getPromoCodes().then(result => {
// 	if (result && result.length === 2) {
// 		result.forEach( promo => {
// 			if (promo === null) return;

// 			setPromoCodes(promo).then( data => {
// 				console.log(data)
// 			})
// 		})
// 	}
// })
